// In order to prevent cycled dependencies
// this code has been temporarily moved here.
import i18n from 'i18n';
import React from 'react';

import { FormField, IField } from '../types';
import { Dropdown, Input, PercentAdornment } from '../components';
import { EMPTY_STRING } from '../constants';
import {
  LTV_TAXES_FEES_FILTER_OPTIONS,
  JDP_VENDOR_FILTER_OPTIONS,
  PREFERENCES_FIELD_NAMES,
  PREFERENCES_PE_FIELD_NAMES,
} from './preferences.const';
import { requiredValidator } from '../validators';
import { ColumnWidth } from '../enums';

export const COMMON_PREFERENCES_FIELDS: IField[] = [
  {
    name: PREFERENCES_FIELD_NAMES.LTV_TAXES_FEES_FILTER,
    component: Dropdown as FormField,
    controlProps: { options: LTV_TAXES_FEES_FILTER_OPTIONS },
    label: EMPTY_STRING,
  },
];

export const LENDER_PREFERENCES_FIELDS: IField[] = [
  {
    name: PREFERENCES_FIELD_NAMES.LTV_TAXES_FEES_FILTER,
    component: Dropdown as FormField,
    controlProps: { disabled: true, options: LTV_TAXES_FEES_FILTER_OPTIONS },
    label: EMPTY_STRING,
  },
];

export const PREFERENCES_FIELDS: IField[] = [
  {
    name: PREFERENCES_FIELD_NAMES.VENDOR_FIELD,
    component: Dropdown as FormField,
    controlProps: { options: JDP_VENDOR_FILTER_OPTIONS },
    label: EMPTY_STRING,
  },
  ...COMMON_PREFERENCES_FIELDS,
];

export const ADVANCED_OVERRIDES_FIELDS: IField[] = [
  {
    label: i18n.t('components.preferences.labels.estApr'),
    name: PREFERENCES_PE_FIELD_NAMES.OVERRIDE_APR,
    component: (props) => <Input {...props} />,
    controlProps: {
      fieldWidth: ColumnWidth.FULL,
      testId: i18n.t('components.preferences.labels.overrideApr'),
      endAdornment: <PercentAdornment />,
      decimalScale: 2,
      placeholder: i18n.t('components.input.placeholders.decimal'),
    },
  },
  {
    label: i18n.t('components.preferences.labels.maxLtv'),
    name: PREFERENCES_PE_FIELD_NAMES.OVERRIDE_LTV,
    component: (props) => <Input {...props} />,
    controlProps: {
      fieldWidth: ColumnWidth.FULL,
      testId: i18n.t('components.preferences.labels.overrideLtv'),
      endAdornment: <PercentAdornment />,
      decimalScale: 2,
      // A deal source's Max LTV is derived from the lender's approved balance and carries far more
      // than 2 decimals. Display it rounded, but send the full value — the rehash rebuilds the
      // lender's dollar cap from this percentage, and the lost decimals become extra cash down.
      preserveIncomingPrecision: true,
      placeholder: i18n.t('components.input.placeholders.decimal'),
    },
  },
];

export const PE_PREFERENCES_FIELDS: IField[] = [
  {
    label: i18n.t('components.preferences.labels.ltvHighLimit'),
    name: PREFERENCES_PE_FIELD_NAMES.LVT_HIGH_LIMIT,
    component: (props) => <Input {...props} />,
    controlProps: {
      endAdornment: <PercentAdornment />,
      decimalScale: 2,
      isRequired: true,
      rules: requiredValidator,
      // 'placeholders.decimal' specifically used in this case, because 'placeholders.percent' has 3 decimal places
      placeholder: i18n.t('components.input.placeholders.decimal'),
    },
  },
  ...PREFERENCES_FIELDS,
];
